import dispatcher from "../dispatcher";
import { userConstant } from "../constants/constants";
import rq from "../components/utility/rq";


export function createUser(user) {
    rq.post("/api/v1/user", user).then(() => {
        dispatcher.dispatch({ type: userConstant.USER_CREATED, user, msg: `User ${user.name} created successfully.` });
    }).catch((data) => {
        dispatcher.dispatch({ type: userConstant.USER_CREATION_FAILED, msg: `creating user ${user.userName} failed ! ${data.responseText}` });
    });
}

export function updatePassword(data) {
    rq.post("/update-password", data).then(() => {
        alert("passworded updated");
        window.location = "/login";
    }).catch((err) => {
        alert(err);
    });

}


// WEBPACK FOOTER //
// ./src/jsx/actions/user-action.jsx